module.exports = __webpack_public_path__ + "img/backup-recruit-advocate-icon.18f5d67b.svg";